import { sq } from "../../../../date-fns/locale/sq.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    sq
  }
};